import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, output } from '@angular/core';
import { kendoIcons } from '@app/shared/library/kendo-icons';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { SVGIconComponent } from '@progress/kendo-angular-icons';
import { LoaderComponent } from '@progress/kendo-angular-indicators';
import { CreateProjectScheduleResult } from '../../models/create-project-schedule-result';
import { CreateProjectScheduleService } from './create-project-schedule.service';

@Component({
  selector: 'app-create-project-schedule',
  templateUrl: './create-project-schedule.component.html',
  styleUrls: ['./create-project-schedule.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonDirective,
    DialogModule,
    LoaderComponent,
    SVGIconComponent,
  ],
})
export class CreateProjectScheduleComponent {
  private service = inject(CreateProjectScheduleService);
  private cdr = inject(ChangeDetectorRef);

  public icons = kendoIcons;
  
  readonly projectId = input<number>(undefined);
  public loading: boolean = false;
  public error: string = null;

  readonly closeDialog = output<void>();

  public createSchedule() {
    this.loading = true;

    this.service.createSchedule(this.projectId())
      .subscribe((result) => {
        this.createScheduleComplete(result);
        this.cdr.detectChanges();
      });
  }

  public onCloseDialog() {
    this.closeDialog.emit();
  }

  private createScheduleComplete(result: CreateProjectScheduleResult) {
    this.loading = false;

    if (result.Error) {
      this.error = result.Error;

      return;
    }

    this.onCloseDialog();
  }
}